import { Navigate, useParams } from 'react-router-dom';
import useDataTestsEnabled from '@elementary/common-ui/hooks/useDataTestsEnabled';
import useHasDbtProjects from '@elementary/common-ui/hooks/useHasDbtProjects';
import AddTestWizardPage from 'shared/components/AddTestWizard/AddTestWizardPage';
import useUrlWithEnv from 'shared/hooks/useUrlWithEnv';
import { isWizardResourceType } from 'testManagement/utils/utils';

const AddTestWizardRoute = () => {
  const { mode } = useParams();
  const getUrlWithEnv = useUrlWithEnv();
  const hasDbtProjects = useHasDbtProjects();
  const isDataTestsEnabled = useDataTestsEnabled();
  const canAddCustomQuery = hasDbtProjects || isDataTestsEnabled;

  if (
    !isWizardResourceType(mode) ||
    (mode === 'columns' && !hasDbtProjects) ||
    (mode === 'customQuery' && !canAddCustomQuery)
  ) {
    return <Navigate to={getUrlWithEnv('/test-management')} replace />;
  }

  return <AddTestWizardPage wizardMode="add" wizardResourceType={mode} />;
};

export default AddTestWizardRoute;
